import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown } from "react-bootstrap";
import i18n from 'I18n';
import ConfirmField from './ConfirmField';

const OtherInfoDropdownField = ({
  language,
  question = {},
  isConfirm,
  editAction,
}) => {
  const {
    placeholder,
    defaultValue,
    fieldName,
    options: sections,
  } = question;

  const [showDropdown, setShowDropdown] = useState(false);
  const [inputValue, setInputValue] = useState(defaultValue);
  const displayValue = useMemo(() => {
    for (const section of sections) {
      if (section.value === defaultValue) {
        return section.label;
      }
    }
    return placeholder || i18n.t('not_provided');
  }, [defaultValue, sections, language]);

  useEffect(() => {
    // init value after click edit button
    setInputValue(defaultValue);
  }, [defaultValue]);

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  if (isConfirm) {
    return (
      <ConfirmField value={displayValue} />
    )
  };

  return (
    <div className="common-item-value field-text">
      <div style={{ width: "100%" }}>
        <Dropdown
          style={{ width: '100%' }}
          onToggle={(isOpen) => {
            setShowDropdown(isOpen);
          }}
          onSelect={(value) => {
            if (value === inputValue) {
              return
            }
            onEdit(value);
          }}
        >
          <Dropdown.Toggle as="div" className={`picker-box gender-picker-box`}>
            <div className="account-input field-text">
              {displayValue}
              <img
                alt="down"
                className="account-down-arrow"
                src={
                  showDropdown
                    ? '/myAccount/up-arrow.png'
                    : '/myAccount/down-arrow.png'
                }
              />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="gender-dropdown">
            {sections?.map((item) => (
              <Dropdown.Item
                className="gender-dropdown-item field-text"
                eventKey={item?.value || ''}
                active={inputValue === item?.value}
              >
                {item?.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default OtherInfoDropdownField;
